<div class="ftr" *ngIf="!partnerCode || partnerCode == 'ps'">
	<div class="ftr__container">
		<!-- Logo -->
		<div class="ftr__column">
			<div class="ftr__logo">
				<span>{{ "footer.poweredBy" | translate }} </span>
				<img
					src="https://storage.googleapis.com/ps-asset/ps_logos/ps_logo_box.png"
					alt="policystreet"
				/>
			</div>
		</div>
		<!-- Address -->
		<div class="ftr__column">
			<div class="ftr__address">
				<span>
					D-3A-05, Menara Suezcap 1, KL Gateway, No. 2 Jalan Kerinchi, Gerbang Kerinchi Lestari, 59200 Kuala Lumpur
				</span>
			</div>
		</div>
		<!-- Contacts -->
		<div class="ftr__column">
			<div>
				<img
					class="ftr__icon"
					src="./assets/icons/footer/whatsapp-fill.png"
					alt=""
				/>
				<span>+6018-282 2320 </span>
			</div>

			<div>
				<img
					class="ftr__icon"
					src="./assets/icons/footer/email-fill.png"
					alt=""
				/>
				<span>customerservice&#64;policystreet.com </span>
			</div>
		</div>
	</div>
	<div class="ftr__bottom">
		<span>
			{{ "footer.desc" | translate }}
		</span>
	</div>
</div>

<!-- Carsome footer -->
<div class="ftr" *ngIf="partnerCode && partnerCode != 'ps'">
	<div class="ftr__container">
		<!-- Logo -->
		<div class="ftr__column">
			<div class="ftr__custom__logo">
				<img [src]="'assets/image/partner/' + partnerCode + '-footer.png'" alt="Partner Logo" />
				<span>{{ partner?.copyright?.value }}</span>
			</div>
		</div>
		<!-- Contacts -->
		<div class="ftr__column">
			<div *ngIf="partner?.mobile?.isDisplay">
				<img
					class="ftr__icon"
					src="./assets/icons/footer/whatsapp-fill.png"
					alt=""
				/>
				<span>{{ partner?.mobile?.value }}</span>
			</div>
			<div>
				<img
					class="ftr__icon"
					src="./assets/icons/footer/email-fill.png"
					alt=""
				/>
				<span>{{ partner?.email?.value }}</span>
			</div>
		</div>
	</div>
	<div class="ftr__bottom">
		<span>
			{{ "footer.desc" | translate }}
		</span>
	</div>
</div>
